import { render, staticRenderFns } from "./Gallery1.vue?vue&type=template&id=5fe1a784&scoped=true&"
import script from "./Gallery1.vue?vue&type=script&lang=js&"
export * from "./Gallery1.vue?vue&type=script&lang=js&"
import style0 from "./Gallery1.vue?vue&type=style&index=0&id=5fe1a784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1a784",
  null
  
)

export default component.exports